import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 90_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

/**
 * After writes that change machines / usage / logs, invalidate related caches.
 * Pass dispenserId + usage to patch the fleet cache instead of blowing it away.
 */
export function patchMachineUsage(dispenserId, usage) {
  if (!dispenserId || !usage) return;
  queryClient.setQueriesData({ queryKey: ['usage'] }, (old) => {
    if (!old || typeof old !== 'object' || Array.isArray(old)) return old;
    return { ...old, [dispenserId]: usage };
  });
}

export function invalidateAfterMachineWrite({ dispenserId, usage } = {}) {
  if (usage && dispenserId) {
    patchMachineUsage(dispenserId, usage);
  } else {
    queryClient.invalidateQueries({ queryKey: ['usage'] });
  }
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: ['dispensers'] }),
    queryClient.invalidateQueries({ queryKey: ['refill-logs'] }),
    queryClient.invalidateQueries({ queryKey: ['technician-stats'] }),
    queryClient.invalidateQueries({ queryKey: ['assignments'] }),
  ]);
}

export function invalidateAfterClientWrite() {
  queryClient.invalidateQueries({ queryKey: ['clients'] });
  queryClient.invalidateQueries({ queryKey: ['dispensers'] });
}

export function invalidateAfterScheduleWrite() {
  queryClient.invalidateQueries({ queryKey: ['schedules'] });
  queryClient.invalidateQueries({ queryKey: ['dispensers'] });
  queryClient.invalidateQueries({ queryKey: ['usage'] });
}
